module.exports = __webpack_public_path__ + "img/Screenshot_EAN13.c29c09f2.png";